export const createWorkspaceEndPoint = `/workspaces`;
export const getWorkspacesEndPoint = '/workspaces';
